import { PAYMENT_ACCOUNT_METHOD } from './payment-account';

/**
 * Estado de um repasse do Stripe (T3.1). Espelha
 * `api/src/payment-account/enum/provider-payout-status.enum.ts`.
 */
export enum PROVIDER_PAYOUT_STATUS {
  PENDING = 'PENDING',
  IN_TRANSIT = 'IN_TRANSIT',
  PAID = 'PAID',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}

/**
 * Um item de `GET /payment-account/payouts` (T3.1, T6.1). Espelha
 * `PayoutListItemDto` campo a campo — `bankLast4` chega cru (sem "••"),
 * quem formata é o app (ver `formatPayoutAccount`, `content/payments/receivables.ts`).
 */
export interface PaymentPayout {
  id: string;
  amount: number;
  status: PROVIDER_PAYOUT_STATUS;
  /** `YYYY-MM-DD`, `null` enquanto o repasse não tem previsão do Stripe. */
  arrivalDate: string | null;
  bankLast4: string | null;
  failureCode: string | null;
  failureMessage: string | null;
  createdAt: string;
}

/**
 * Uma cobrança dentro de `GET /payment-account/payouts/:id` (T3.1, T6.2).
 * Espelha `PayoutChargeItemDto` — `clientName`/`serviceName` chegaram na
 * T7.1 (achado da T6.1/T6.2: evitam o app buscar `GET /charge/:id` por
 * cobrança só para exibir o nome do cliente, ver T6.5 no Registro).
 */
export interface PaymentPayoutCharge {
  id: string;
  paymentMethodUsed: PAYMENT_ACCOUNT_METHOD | null;
  grossAmount: number | null;
  feeAmount: number | null;
  netAmount: number | null;
  paidAt: string | null;
  clientName: string | null;
  serviceName: string | null;
}

/**
 * `GET /payment-account/payouts/:id` (T3.1, T6.2). Espelha `PayoutDetailDto`.
 * `chargesNetTotal` é a soma de `netAmount` das cobranças — conferência de
 * conveniência; quem bate com `amount` (o valor real do repasse) é a tela
 * (T6.2: mostrar a diferença como "ajustes", nunca escondê-la).
 */
export interface PaymentPayoutDetail extends PaymentPayout {
  charges: PaymentPayoutCharge[];
  chargesNetTotal: number;
}
